import { css } from "@emotion/core";
import React, { ReactNode } from "react";

import {
  useTheme,
  Typography,
  Colors as ThemeColors,
  Spacer,
} from "@zapier/design-system";

import { Colors, breakpoints } from "@zapier/checkout/esm/constants";

type Props = {
  children: ReactNode;
  title?: string;
};

const headingCss = css`
  color: ${Colors.deepSpace};
  font-size: 1.2em;
  font-weight: 600;
  margin-bottom: 1em;
  margin-top: 2em;
  padding: 0;
`;

const rebrandHeadingCss = css`
  color: ${ThemeColors.neutral800};
  ${Typography.sectionHeader3Bold};
  margin: 3rem 0;
  @media screen and (max-width: ${breakpoints.mobileMax}px) {
    margin: 2rem 0;
  }
`;

const sectionCss = css`
  margin-bottom: 2em;
`;

export const ChangePlanSection = (props: Props) => {
  const { isRebrand } = useTheme();
  return (
    <section css={sectionCss}>
      {props.title ? (
        <h2 css={[headingCss, isRebrand && rebrandHeadingCss]}>
          {props.title}
        </h2>
      ) : (
        <Spacer height="3rem" />
      )}
      {props.children}
    </section>
  );
};
